'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFields = require('../createFields');

var _createFields2 = _interopRequireDefault(_createFields);

var _immutable = require('../structure/immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createFields2.default)(_immutable2.default);


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/immutable/Fields.js
 ** module id = 1291
 ** module chunks = 1
 **/